// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ps-sidebar-container {
    background-color: transparent!important;
    color: white!important;
    font-size: 0.8rem;
}


.pro-sidebar .ps-menuitem-root {
    transition: background 0.3s, color 0.3s;
}

.pro-sidebar .ps-menuitem-root:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: #ffffff;
}

.pro-sidebar .ps-menuitem-root span {
    transition: color 0.3s;
}

.ps-sidebar-container {
    display: flex;
    flex-direction: column;
}

.ps-menuitem-root .ps-active {
    background-color: #08aac4;
    color: white;
}

.ps-menu-root {
    width: 100%;
}

.ps-menu-label, .ps-menu-icon {
    background-color: transparent !important;
}

.ps-menuitem-root > .ps-menu-button:hover {
    background-color: rgba(0, 0, 0, 0.1) !important;
}`, "",{"version":3,"sources":["webpack://./src/main/frontend/components/SidenavPro/styles/sidenavpro.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,iBAAiB;AACrB;;;AAGA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+CAA+C;AACnD","sourcesContent":[".ps-sidebar-container {\n    background-color: transparent!important;\n    color: white!important;\n    font-size: 0.8rem;\n}\n\n\n.pro-sidebar .ps-menuitem-root {\n    transition: background 0.3s, color 0.3s;\n}\n\n.pro-sidebar .ps-menuitem-root:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    color: #ffffff;\n}\n\n.pro-sidebar .ps-menuitem-root span {\n    transition: color 0.3s;\n}\n\n.ps-sidebar-container {\n    display: flex;\n    flex-direction: column;\n}\n\n.ps-menuitem-root .ps-active {\n    background-color: #08aac4;\n    color: white;\n}\n\n.ps-menu-root {\n    width: 100%;\n}\n\n.ps-menu-label, .ps-menu-icon {\n    background-color: transparent !important;\n}\n\n.ps-menuitem-root > .ps-menu-button:hover {\n    background-color: rgba(0, 0, 0, 0.1) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
